export const PASSWORD_RULE = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;
export const PASSWORD_MESSAGE = 'Use at least 12 characters including a letter, a number and a symbol.';
export function isStrongPassword(pw: string): boolean {
  return PASSWORD_RULE.test(pw);
}
